export const RECALENDAR_JS_GITHUB =
	'https://github.com/klimeryk/recalendar.js/';
export const RECALENDAR_PHP_GITHUB = 'https://github.com/klimeryk/recalendar/';

export const HOME_PATH = '/';
export const CONFIGURATOR_PATH = '/create';
export const FEATURES_PATH = '/features';
export const FAQ_PATH = '/faq';
